import { Skeleton } from "@/components/ui/skeleton"
import { useReplaceBootScreen } from "@/lib/boot-screen"

/**
 * Shown only while the session or the shell is indeterminate. Drawn on the
 * shell's own grid (`AppShell`), so nothing moves when it resolves (PDD §11.2
 * state 1):
 *  - from `md`, a 16rem sidebar with a 56px brand row and its bottom border;
 *  - menu rows at the real menu's pitch: 32px rows, 4px apart, 8px in;
 *  - a 56px top bar with the trigger and the two toggles (44px on phones);
 *  - the page heading and its first line where the real ones land, inside the
 *    content's padding (16px on phones, 24px from `md`).
 */
export function FullPageLoader() {
  useReplaceBootScreen()
  return (
    <div className="flex h-dvh w-full bg-background" aria-busy="true" aria-live="polite">
      <div
        data-testid="loader-sidebar"
        className="hidden w-64 shrink-0 flex-col border-r border-border bg-sidebar md:flex"
      >
        <div className="flex h-14 items-center border-b border-border px-4">
          <Skeleton className="h-5 w-24 bg-sidebar-skeleton" />
        </div>
        <div data-testid="loader-menu" className="flex flex-col gap-1 p-2">
          {Array.from({ length: 8 }, (_, i) => (
            <Skeleton key={i} className="h-8 w-full bg-sidebar-skeleton" />
          ))}
        </div>
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div
          data-testid="loader-topbar"
          className="flex h-14 items-center gap-1 border-b border-border px-2 md:gap-2 md:px-4"
        >
          <Skeleton className="size-7 max-md:size-11" />
          <div className="ml-auto flex items-center gap-1">
            <Skeleton className="size-9 max-md:size-11" />
            <Skeleton className="size-9 max-md:size-11" />
          </div>
        </div>
        <div data-testid="loader-content" className="p-4 md:p-6">
          <div className="space-y-2">
            <Skeleton className="h-8 w-56" />
            <Skeleton className="h-5 w-72 max-w-full" />
          </div>
        </div>
      </div>
    </div>
  )
}
